import './styles/user-list-header.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import { Button } from 'semantic-ui-react'

export default class UserListHeader extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  }

  handleNewUser = () => {
    this.props.history.push('/users/item/new')
  }

  render() {    
    return (
      <div className="user-list-header">
        <Button primary onClick={this.handleNewUser}>New User</Button>
      </div>
    )
  }
}